import Reveal from '../../../shared/Reveal/Reveal';
import { usePlatformsEngineeredContent } from '../../../../hooks/usePlatformsEngineeredContent';
import './Engineered.css';

const Engineered = () => {
  const { content, isLoading } = usePlatformsEngineeredContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, features } = content;

  return (
    <section className="platforms-engineered">
      <div className="platforms-engineered__inner">
        <Reveal>
          <h2 className="platforms-engineered__title">{title}</h2>
        </Reveal>

        <div className="platforms-engineered__grid">
          {features.map(({ title: featureTitle, text }, index) => (
            <Reveal key={featureTitle} delay={index * 70}>
              <article className="platforms-engineered__card">
                <h3 className="platforms-engineered__card-title">{featureTitle}</h3>
                <p className="platforms-engineered__card-text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Engineered;
